






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SocialButton extends Vue {
  @Prop({ required: true, type: String, default: '' }) readonly social!: string
  @Prop({ type: String, default: '' }) readonly dataAction?: string
  @Prop({ type: String, default: '' }) readonly dataFnAction?: string
}
